import { QueryClient } from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // This could prevent duplicate requests
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      staleTime: Infinity, // or some reasonable value
    },
  },
});

export default queryClient;
